import cfJS from "../Engine/cfJS";
import engine from "../Engine/Engine";
import CurrentUser from "../CurrentUser/CurrentUser";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";

// Для работы необходим сервис воркер в корне проекта с названием firebase-messaging-sw.js

class PushNotifications {

    constructor(config, host, port) {
        this.config = config;
        this.host = host || location.origin;
        this.port = port || 8003;
        this.app = initializeApp(config);
        this.messaging = getMessaging(this.app);
        this.user = null;

        onMessage(this.messaging, (payload) => {
          console.log('Message received. ', payload);
          const notificationTitle = payload.notification.title;
          const notificationOptions = {
            body: payload.notification.body,
            icon: payload.notification.icon
          };

          new Notification(notificationTitle,notificationOptions);
        });
    }

    getUser() {
        return new Promise((resolve, reject) => {
            if (this.user) {
                resolve(this.user);
            }
            const currentUser = new CurrentUser();
            currentUser.fentchUser()
            .then((user) => {
                this.user = user;
                resolve(user);
            })
            .catch(() => {
                resolve(null);
            });
        });
    }

    getURL() {
        return `${this.host}:${this.port}`;
    }

    subscribe() {
        getToken(this.messaging)
        .then((currentToken) => {
            console.log(currentToken);
            if (currentToken) {
                this.fentchSubscribe(currentToken)
            } else {
                console.error('Не удалось получить токен.');
            }
        })
        .catch((err) => {
            console.error('При получении токена произошла ошибка.', err);
        });
    }

    unsubscribe() {
        deleteToken(this.messaging);
    }

    async fentchSubscribe(token) {
        this.getUser()
        .then((user) => {
            const requestData = {
                token
            };
            console.log(user);
            if (user) {
                requestData.userId = user.id;
            }
            try {
                engine.postRequest(
                    `${this.getURL()}/subscribe`,
                    requestData,
                    ()=>{},
                    { 'Content-Type': 'application/json' }
                );
            }
            catch (err) {
                console.error(err);
            }
        });
    }
}

window.PushNotifications = PushNotifications;

// const c = new window.PushNotifications({
//     apiKey: "AIzaSyDbE6u6WDHFxJyermZbPGScOH7Kv4voJio",
//     authDomain: "test-70bc3.firebaseapp.com",
//     projectId: "test-70bc3",
//     storageBucket: "test-70bc3.appspot.com",
//     messagingSenderId: "112112600212",
//     appId: "1:112112600212:web:fd062c2c0d016ac3f7e081"
// })

// c.subscribe();

// c.unsubscribe();